import { actionProps } from "@/lib/controlAnalytics";
import { ArrowUpRightIcon } from "@/components/icons";

/** A link out to the posting or its apply page, in a new tab. */
export default function LinkChip({ href, children }: { href: string; children: string }) {
    return (
        <a
            {...actionProps("history_external_link_clicked", {
                source: "History.LinkChip",
                section: children.toLowerCase(),
            })}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex h-[26px] max-[760px]:min-h-11 items-center gap-1 whitespace-nowrap rounded-[7px] border border-line px-2 text-[11.5px] font-semibold text-fg-muted transition-colors hover:border-line-strong hover:text-fg"
        >
            {children}
            <ArrowUpRightIcon className="size-[11px]" strokeWidth={2.2} />
        </a>
    );
}
